import { BubbleEditor, useBubbleEditor } from "@caelor/ui";
import React from "react";
import { usePanelSimpleStore } from "../../../../stores/use-panel-simple-store";
import { Text } from "./styled";
import DOMPurify from "dompurify";

function TextEdit({ data, textColor, isEditable, isTemplate }) {
  const { id, text } = data;

  const {
    content,
    isVisible,
    position,
    storedSelection,
    isInLinkMode,
    setIsInLinkMode,
    handleFormat,
    handleLinkAdd,
    handleClose,
  } = useBubbleEditor(`${id}-standard`);

  const setData = usePanelSimpleStore((state) => state.setData);

  return (
    <>
      <Text
        id={`${id}-standard`}
        clr={textColor}
        isTemplate={isTemplate}
        contentEditable={isEditable}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(text),
        }}
        onBlur={() => {
          setData({ text: content });
        }}
      />
      {isEditable && (
        <BubbleEditor
          options={[
            "bold",
            "italic",
            "underline",
            "list",
            "numbered-list",
            "link",
          ]}
          isVisible={isVisible}
          position={position}
          storedSelection={storedSelection}
          isInLinkMode={isInLinkMode}
          setIsInLinkMode={setIsInLinkMode}
          onFormat={handleFormat}
          onLinkAdd={handleLinkAdd}
          onClose={handleClose}
        />
      )}
    </>
  );
}

export default TextEdit;
